import { render, staticRenderFns } from "./CategorySelect.vue?vue&type=template&id=5921a017&scoped=true&"
import script from "./CategorySelect.vue?vue&type=script&lang=js&"
export * from "./CategorySelect.vue?vue&type=script&lang=js&"
import style0 from "./CategorySelect.vue?vue&type=style&index=0&id=5921a017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5921a017",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5921a017')) {
      api.createRecord('5921a017', component.options)
    } else {
      api.reload('5921a017', component.options)
    }
    module.hot.accept("./CategorySelect.vue?vue&type=template&id=5921a017&scoped=true&", function () {
      api.rerender('5921a017', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/user/CategorySelect.vue"
export default component.exports